import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { environment } from '../environments/environment';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { ShaftSealProduct } from './models/shaft-seal-product.interface';

const SHAFT_SEAL_PRODUCT_API: string = environment.api_url;

@Injectable()
export class ShaftSealProductSelectorService {
  constructor(private http: Http) {}

  getShaftSealProducts(params): Observable<ShaftSealProduct[]> {
    let headers = new Headers({
      'Content-type': 'application/json'
    });

    let options = new RequestOptions({
      headers: headers,
      params: params
    });

    return this.http
      .get(SHAFT_SEAL_PRODUCT_API, options)
      .map((response: Response) => response.json())
      .catch((error: any) => Observable.throw({status: error.status, message: error.statusText}));
  }
}


// WEBPACK FOOTER //
// ./app/javascript/product_search/app/shaft-seal-product-selector/shaft-seal-product-selector.service.ts